module.exports = __webpack_public_path__ + "images/img-huanbao-d92c8e8fe0.png";